import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SessionMessageComponent } from '@app/management/planning/session-message/session-message.component'
import { SessionEnrollmentComponent } from '@app/management/planning/session-enrollment/session-enrollment.component'
import { SessionEnrollmentEventsComponent } from '@app/management/planning/session-enrollment/session-enrollment-events/session-enrollment-events.component'
import { NoticeSessionActionsComponent } from '@app/management/planning/session-enrollment/notice-session-actions/notice-session-actions.component'
import { ItemsComponent } from '@app/management/planning/items/items.component'
import { OWL_DATE_TIME_LOCALE, OWL_DATE_TIME_FORMATS, OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker'
import { DateUtil } from '@utils/date.util'
import { AppCommonModule } from '@common/app-common.module'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { NgSelectModule } from '@ng-select/ng-select'
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask'
import { NoticeSessionChatComponent } from '@app/management/planning/chat/notice-session-chat.component'
import { NoticeSessionChatLauncherComponent } from '@app/management/planning/chat/notice-session-chat-launcher.component'
import { AttachmentsComponent } from '@app/management/planning/attachments/attachments.component'
import {
	ElectronicProcessFormModule
} from '@app/management/planning/electronic-processes/electronic-process-form/electronic-process-form.module'

@NgModule({
	declarations: [
		ItemsComponent,
		SessionMessageComponent,
		SessionEnrollmentComponent,
		SessionEnrollmentEventsComponent,
		NoticeSessionActionsComponent,
		NoticeSessionChatComponent,
		NoticeSessionChatLauncherComponent,
		AttachmentsComponent
	],
	exports: [
		SessionMessageComponent,
		SessionEnrollmentComponent,
		SessionEnrollmentEventsComponent,
		NoticeSessionActionsComponent,
		ItemsComponent,
		NoticeSessionChatComponent,
		NoticeSessionChatLauncherComponent,
		AttachmentsComponent
	],
	imports: [
		NgxMaskPipe,
		AppCommonModule,
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		NgSelectModule,
		NgxMaskDirective,
		OwlDateTimeModule,
		ElectronicProcessFormModule
	],
	providers: [
		{ provide: OWL_DATE_TIME_LOCALE, useValue: 'pt-Br' },
		{ provide: OWL_DATE_TIME_FORMATS, useValue: DateUtil.myMomentFormats() }
	]
})
export class SessionMessagePartialModule {}
